(() => {
  if (window.__mvsBuyNowInitialized) return;
  window.__mvsBuyNowInitialized = true;

  const getScope = (node) => node?.closest?.('.shopify-section') || document;

  const syncButtons = (scope = document) => {
    scope.querySelectorAll?.('.product-form').forEach((productForm) => {
      const addButton = productForm.querySelector('button[name="add"]');
      const buyNowButton = productForm.querySelector('[data-buy-now-button]');
      if (!addButton || !buyNowButton) return;
      buyNowButton.disabled = addButton.disabled;
      buyNowButton.setAttribute('aria-disabled', addButton.disabled ? 'true' : 'false');
    });
  };

  const buyNow = async (button) => {
    const form = button.closest('form');
    if (!form) return;
    const addButton = form.querySelector('button[name="add"]');
    if (addButton?.disabled) return;

    const formData = new FormData(form);
    formData.delete('sections');
    formData.delete('sections_url');

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      });
      if (!response.ok) throw new Error('Buy now failed');
      window.location.href = `${root}checkout`;
    } catch (error) {
      console.error('MVS buy now fallback', error);
      const returnInput = document.createElement('input');
      returnInput.type = 'hidden';
      returnInput.name = 'return_to';
      returnInput.value = '/checkout';
      form.appendChild(returnInput);
      HTMLFormElement.prototype.submit.call(form);
    }
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest?.('[data-buy-now-button]');
    if (!button) return;
    event.preventDefault();
    if (button.disabled || button.getAttribute('aria-busy') === 'true') return;
    buyNow(button);
  });

  document.addEventListener('variant:change', (event) => syncButtons(getScope(event.detail?.formElement)));
  document.addEventListener('DOMContentLoaded', () => syncButtons(document));
  document.addEventListener('shopify:section:load', (event) => syncButtons(getScope(event.target)));
})();
